import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

import UploadPreloader from '../upload-preloader/UploadPreloader';
import useWindowDropZone from './UseWindowDropZone';

import DndBar from './DragAndDropBar';
import { UPLOAD_PRELOADER_STATES } from '@mdc/constants';
import { withUploadPreloaderProvider } from '@mdc/services';

export const DropZoneContext = createContext();

const DropZoneProvider = (props) => {
    const [onFileDropSubscribers, setOnFileDropSubscribers] = useState([]);

    const addSubscriber = (callback, id) => {
        const subscribers = id ? onFileDropSubscribers.filter((sub) => sub.id !== id) : onFileDropSubscribers;
        setOnFileDropSubscribers([...subscribers, { callback, id }]);
    };

    const isInProgress = () => props.uploadProvider.getPreloaderState() === UPLOAD_PRELOADER_STATES.IN_PROGRESS;

    useWindowDropZone({
        onDrop: (event) => {
            if (isInProgress()) {
                return;
            }

            const { files } = event.dataTransfer;
            props.uploadProvider.setPreloaderState(UPLOAD_PRELOADER_STATES.INACTIVE);
            if (!files.length) {
                return;
            }
            onFileDropSubscribers.forEach((sub) => {
                sub.callback(files);
            });
        },
        onDragEnter: () => {
            if (isInProgress()) {
                return;
            }

            props.uploadProvider.setPreloaderState(UPLOAD_PRELOADER_STATES.WAITING);
        },
        onDragLeave: () => {
            if (isInProgress()) {
                return;
            }

            props.uploadProvider.setPreloaderState(UPLOAD_PRELOADER_STATES.INACTIVE);
        }
    });

    return (
        <DropZoneContext.Provider value={{
            onFileDrop: addSubscriber
        }}
        >
            {props.children}
            <DndBar/>
            <UploadPreloader state={props.uploadProvider.getPreloaderState()}/>
        </DropZoneContext.Provider>
    );
};

DropZoneProvider.propTypes = {
    children: PropTypes.node.isRequired,
    uploadProvider: PropTypes.any.isRequired,
};

export default withUploadPreloaderProvider(DropZoneProvider);

export const DropZoneConsumer = (props) => {
    const extraProps = {};
    /* eslint-disable no-unused-vars */
    for (let key in props) {
        if (key !== 'children') {
            extraProps[key] = props[key];
        }
    }
    /* eslint-enable no-unused-vars */
    return (
        <DropZoneContext.Consumer>
            {({ onFileDrop }) => {
                const children = props.children;
                return React.Children.map(children, (child) => {
                    return React.cloneElement(child, { ...extraProps, onFileDrop });
                });
            }}
        </DropZoneContext.Consumer>
    );
};

DropZoneConsumer.propTypes = {
    children: PropTypes.node.isRequired,
};
